import { message } from "antd";
import { runInAction } from "mobx";
import { BaseErrorData } from "../api";

/** 独立请求状态类型 */
export type RequestStatus = {
  loading: boolean;
  error: string;
  errorCode: string;
  status: number;
};

export function createRequestStatus(): RequestStatus {
  return {
    loading: false,
    error: "",
    errorCode: "",
    status: 0,
  };
}


/** 请求状态重置 */
export function resetStatus(statusObj: RequestStatus) {
  statusObj.loading = true;
  statusObj.error = "";
  statusObj.errorCode = "";
  statusObj.status = 0;
}

/** 结束 loading */
export function finishStatus(statusObj: RequestStatus) {
  statusObj.loading = false;
}

/** 错误处理 */
export function setErrorStatus(statusObj: RequestStatus, res: BaseErrorData & { kind: string }, defaultMessage: string) {
  statusObj.error = res.message || defaultMessage;
  statusObj.errorCode = res.kind
  statusObj.status = res.status
  if (defaultMessage !== '1') {
    // message.error(statusObj.error);
  }
}

/** 成功处理 */
export function setSuccessStatus(statusObj: RequestStatus, status: number = 200) {
  statusObj.status = status;
  statusObj.error = "";
  statusObj.errorCode = "";
}


/** 通用的异步请求辅助方法 */
export async function handleRequest<ItemT>(
  statusObj: RequestStatus,
  apiCall: () => Promise<any>,
  onSuccess: (res: ItemT) => void,
  defaultErrMsg: string,
  onError?: (res: any) => void,
) {
  resetStatus(statusObj);
  try {
    const res = await apiCall();
    if (res.kind === "ok") {
      runInAction(() => {
        onSuccess(res.data);
        setSuccessStatus(statusObj, 200);
      });
    } else {
      runInAction(() => {
        setErrorStatus(statusObj, res, defaultErrMsg);
        onError && onError(res)
      });
    }
  } finally {
    runInAction(() => {
      finishStatus(statusObj);
    });
  }
}



/**
 * 分页加载更多（通用工具）
 * @param options 配置对象
 * @template ItemT 单项类型
 * @template ApiDataT 接口（包含 items/total/page/pageSize）
 */
export async function handleLoadMoreRequest<
  ItemT,
  ListItemT
>(options: {
  dataList: ItemT[];
  setDataList: (arr: ItemT[]) => void;
  setTotal: (n: number) => void;
  statusObj: RequestStatus;
  apiCall: (limit?: number, lastId?: string) => Promise<any>;
  onSuccess?: (data: ListItemT) => void;
  setNoMoreData: (flag: boolean) => void; // 新增
  lastId?: string;
  limit?: number;
  defaultErrMsg: string;
}) {
  const {
    dataList, setDataList, setTotal,
    statusObj, apiCall, onSuccess, defaultErrMsg,
    lastId, limit, setNoMoreData,
  } = options;
  // 加载更多loading
  statusObj.loading = true;
  try {
    const res = await apiCall(limit, lastId);
    if (res.kind === "ok") {
      const items = res.data.items || [];
      runInAction(() => {
        setDataList([...dataList, ...items]);
        setTotal(res.data.total || 0);
        setNoMoreData(items.length === 0); // 关键：如果本次没数据，置为 true
        onSuccess?.(res.data);
        setSuccessStatus(statusObj, 200);
      });
    } else {
      runInAction(() => {
        setErrorStatus(statusObj, res, defaultErrMsg);
      });
    }
  } finally {
    runInAction(() => {
      finishStatus(statusObj);
    });
  }
}